import { httpClient } from "../../../http-client";
import { ApiUrlBuilder } from "../../shared/constants/apiUrl";
import { EquipmentCharacteristicsModel } from '../models/equipment-characteristics.model';
import { GetComponentTypeView } from '../types/component-type.type';
import { getCause } from '../../../http-client/interceptors/error.interceptor';
import { MetaLibrarySystemModel } from '../models/meta-library.model';
import { MetaLibrarySystemView } from '../types/meta-library.types';

const MetaLibraryServiceImplementation = {
  getCharacteristics: (orga: string, componentTypeCodes: string[] = []): Promise<EquipmentCharacteristicsModel[]> => {
    return httpClient
      .post(ApiUrlBuilder.getCharacteristics(orga), {
        body: JSON.stringify(componentTypeCodes),
      })
      .then((response) => response.json())
      .then((response) => {
        if (Array.isArray(response)) {
          return response.map((componentTypeView: unknown) => {
            const isGetComponentTypeView = (getComponentTypeView: any): getComponentTypeView is GetComponentTypeView =>
              "typeId" in getComponentTypeView &&
              "code" in getComponentTypeView &&
              "designation" in getComponentTypeView &&
              "lineName" in getComponentTypeView &&
              "columnName" in getComponentTypeView &&
              "characteristics" in getComponentTypeView;
            if (isGetComponentTypeView(componentTypeView)) {
              return {
                typeId: componentTypeView.typeId,
                code: componentTypeView.code,
                designation: componentTypeView.designation,
                lineName : componentTypeView.lineName,
                columnName : componentTypeView.columnName,
                characteristics: componentTypeView.characteristics
              };
            } else {
              throw new Error(`response contains: ${JSON.stringify(response)}`, { cause: getCause( 500) });
            }
          });
        } else {
          throw new Error(`response contains: ${JSON.stringify(response)}`, { cause: getCause(response?.status || 500) });
        }
      });
  },

  getMetaLibrary: (orga: string): Promise<MetaLibrarySystemModel[]> => {
    return httpClient
      .get(ApiUrlBuilder.getMetaLibrary(orga))
      .then((response) => response.json())
      .then((response) => {
        if (Array.isArray(response)) {
          return response.map((metaLibrarySystemView: unknown) => {

            const isMetaLibrarySystemView = (metaLibrarySystemView: any): metaLibrarySystemView is MetaLibrarySystemView =>
              "systemTypeId" in metaLibrarySystemView &&
              "code" in metaLibrarySystemView &&
              "system" in metaLibrarySystemView &&
              "metaLibrarySubSystems" in metaLibrarySystemView;

            if (isMetaLibrarySystemView(metaLibrarySystemView)) {
              return {
                systemTypeId: metaLibrarySystemView.systemTypeId,
                code: metaLibrarySystemView.code,
                system: metaLibrarySystemView.system,
                metaLibrarySubSystems : metaLibrarySystemView.metaLibrarySubSystems
              };
            } else {
              throw new Error(`response contains: ${JSON.stringify(response)}`, { cause: getCause( 500) });
            }

          });
        } else {
          throw new Error(`response contains: ${JSON.stringify(response)}`, { cause: getCause(response?.status || 500) });
        }
      });
  }
};

export const MetaLibraryService: Readonly<typeof MetaLibraryServiceImplementation> = MetaLibraryServiceImplementation;



